export const environment = {
  production: false,
  apiUrl: 'https://test-api.lagofest.org',
  isTest: true,
};
